import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Shell } from '@app/shell/shell.service';

import { ProjectFilesComponent } from './project-files.component';

const routes: Routes = [
  Shell.publicRoutes([{ path: 'download', component: ProjectFilesComponent, data: { title: 'Files' } }]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class ProjectFilesRoutingModule {}
